// Kept free of imports: themes/index imports every theme, and the themes import this,
// so it cannot live in themes/utils (which imports themes/index) without a cycle that
// breaks depending on which module happens to load first.
export const extend = (extending, newTheme) => {
  return { ...extending, ...newTheme }
}
